import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { giftCardMobx } from '@mobxStore'
import { MktEmpty } from '@cps'
import { useHistoryNew } from '@utils'
import { amountAdd } from 'common/utils'
import mktController from 'controllers/mktController'
import { MktHeader, CardShape } from 'pages/mkt/components'
import { getGiftCardName } from '@common/utils/giftcard'
import { useGiftCardDecorationInit, useGiftCardPageTitle } from '@common/hooks'
import i18n from 'i18next'
import { toPrice } from '@dt/fe-utils'
import './index.scss'

import GcBgImg from '@img/mkt/giftcard/gc-bg.png'
import handTopImg from '@img/mkt/giftcard/hand-top.png'
import handBottomImg from '@img/mkt/giftcard/hand-bottom.png'

interface IProps extends IPage, RouteComponentProps { }

const GiftCard: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  // const { pageLevel } = match.params as any
  const { eGiftCardList, getEGiftCardList, decorationInfo } = giftCardMobx
  const [selectId, setSelectId] = useState<string>('')
  const handleGo = (cardId: string) => {
    setSelectId(cardId)
    setTimeout(() => {
      history.push(`/giftCard/buy/${cardId}`)
    }, 100)
  }
  const goBack = () => {
    mktController.goBack(history)
  }
  const gcStyle = () => {
    if (eGiftCardList.length === 1) {
      return [{ size: 80, transform: 'translateY(-5%) rotate(50deg)' }]
    } else if (eGiftCardList.length === 2) {
      return [{ size: 74, transform: 'translate(-6%, 10%) rotate(-25deg)' }, { size: 68, transform: 'translateX(9%) rotate(-16deg)' }]
    } else if (eGiftCardList.length === 3) {
      return [
        { size: 60, transform: 'translate(12%, 16%) rotate(-37deg)' },
        { size: 55, transform: 'translate(-33%, 10%) rotate(15deg)' },
        { size: 74, transform: 'translateX(10%) rotate(-53deg)' }
      ]
    } else {
      return [
        { size: 68, transform: 'translate(35%, -30%) rotate(58deg)' },
        { size: 54, transform: 'translate(5%, -46%) rotate(-18deg)' },
        { size: 46, transform: 'translate(110%, -66%) rotate(15deg)' },
        { size: 60, transform: 'translate(10%, -35%) rotate(-18deg)' }
      ]
    }
  }
  const getRechargeInfo = (reloadAmounts: any) => {
    const info = reloadAmounts.find(item => item.ifRecommend) || reloadAmounts[0]
    return info
  }
  useIonViewWillEnter(() => {
    setSelectId('')
    getEGiftCardList()
  }, [])

  useGiftCardDecorationInit()
  useGiftCardPageTitle()

  const renderRecommend = (recommendInfo, reloadType?: string) => {
    if (!recommendInfo) return null
    return (
      <div className='giftcard-detail'>
        {reloadType === 'discountFee' && recommendInfo.give ? (
          <span>{i18n.t('order.chargeFull', { price: toPrice(amountAdd(recommendInfo.recharge, recommendInfo.give)) })}{i18n.t('order.chargeSub', { price: toPrice(recommendInfo.give) })}</span>
        ) : (
          <span>{i18n.t('mkt.giftCard.recharge')}{toPrice(recommendInfo.recharge)}{recommendInfo.give > 0 && i18n.t('mkt.giftCard.giveAway')}{recommendInfo.give > 0 && toPrice(recommendInfo.give)}</span>
        )}
      </div>)
  }
  const showCardName = decorationInfo?.purchaseDecorates?.basicInfo?.showCardName === 1
  const showCardAmount = decorationInfo?.purchaseDecorates?.basicInfo?.showCardAmount === 1
  return (
    <IonPage
      className='giftcard-page'
    >
      <MktHeader onBack={() => mktController.goBack(history)} title={getGiftCardName('pageName.buyGiftCard', 'pageName.buyGiftCardCustom')}>
        <div data-cypid='mmgToMyGCard' className='apply-card-tit' onClick={() => history.push('/iGc')}><i className='iconfont icon-yuyuehuanka-lan'></i>{getGiftCardName('mkt.giftCard.myGiftCard', 'mkt.giftCard.myGiftCardCustom')}</div>
      </MktHeader>
      {
        eGiftCardList?.length > 3
          ? (
            <IonContent className='page-content'>
              <div className='card-list' style={{ backgroundImage: `url(${GcBgImg})` }}>
                {
                  eGiftCardList?.length && eGiftCardList.map((item: IEGiftCardInfo, index: number) => {
                    const itemStyle = gcStyle()[index % 4]
                    const shape = item.covers && item.covers[0]?.shapes ? item.covers[0].shapes[0] : 'rectangle'
                    const rotate = [-58, 18, -15, 18]
                    const recommendInfo = item?.reloadAmounts?.length ? getRechargeInfo(item.reloadAmounts) : null
                    return (
                      <div
                        data-cypid='mmgToGCardBuy'
                        onClick={() => handleGo(item.giftcardId)}
                        key={index}
                        style={{ width: `${itemStyle.size}vw`, height: `${itemStyle.size}vw`, transform: selectId === item.giftcardId ? 'none' : itemStyle.transform }}
                        className={`giftcard-item giftcard-item-${index % 4} ${selectId === item.giftcardId ? 'select-card-id' : ''}`}
                      >
                        {selectId === item.giftcardId && <div className='hand-top-move' style={{ backgroundImage: `url(${handTopImg})` }}></div>}
                        <CardShape cardFace={item.covers[0].url} border='border' shape={shape}></CardShape>
                        {selectId === item.giftcardId && <div className='hand-bottom-move' style={{ backgroundImage: `url(${handBottomImg})` }}></div>}
                        {(showCardName || showCardAmount) && (
                          <div className='info-block' style={{ transform: `rotate(${rotate[index % 4]}deg)` }}>
                            <div className='gc-info-block'>
                              {recommendInfo?.ifRecommend && <div className='giftcard-reco'>{i18n.t('mkt.giftCard.recommend')}</div>}
                              {showCardName && (
                                <div className='info-name'>{item.giftcardName}</div>
                              )}
                              {showCardAmount && renderRecommend(recommendInfo, item.reloadType)}
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  })
                }
              </div>
            </IonContent>
          ) : (
            <IonContent>
              {
                eGiftCardList?.length ? (
                  <div className='page-content-fixed' style={{ backgroundImage: `url(${GcBgImg})`, paddingTop: eGiftCardList.length === 3 ? '50px' : '0' }}>
                    {
                      eGiftCardList?.length && eGiftCardList.map((item: IEGiftCardInfo, index: number) => {
                        const itemStyle = gcStyle()[index]
                        const shape = item.covers && item.covers[0]?.shapes ? item.covers[0].shapes[0] : 'rectangle'
                        const recommendInfo = item?.reloadAmounts?.length ? getRechargeInfo(item.reloadAmounts) : null
                        const rotate = eGiftCardList.length === 3 ? [37, -15, 53] : eGiftCardList.length === 2 ? [25, 16] : [-50]
                        return (
                          <div className={`giftcard-item${selectId === item.giftcardId ? eGiftCardList.length === 1 ? ' select-card-id1' : ' select-card-id' : ''}`} onClick={() => handleGo(item.giftcardId)} style={{ width: `${itemStyle.size}vw`, height: `${itemStyle.size}vw`, transform: itemStyle.transform }} key={index}>
                            {selectId === item.giftcardId && <div className='hand-top-move' style={{ backgroundImage: `url(${handTopImg})` }}></div>}
                            <CardShape cardFace={item.covers[0].url} border='border' shape={shape}></CardShape>
                            {selectId === item.giftcardId && <div className='hand-bottom-move' style={{ backgroundImage: `url(${handBottomImg})` }}></div>}
                            {(showCardName || showCardAmount) && (
                              <div className='info-block' style={{ transform: `rotate(${rotate[index]}deg)` }}>
                                <div className='gc-info-block'>
                                  {recommendInfo?.ifRecommend && <div className='giftcard-reco'>{i18n.t('mkt.giftCard.recommend')}</div>}
                                  {showCardName && <div className='info-name'>{item.giftcardName}</div>}
                                  {showCardAmount && renderRecommend(recommendInfo, item.reloadType)}
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      })
                    }
                  </div>
                ) : (
                  <MktEmpty />
                )
              }
            </IonContent>
          )
      }
    </IonPage>
  )
}

export default observer(GiftCard)
